import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar, Modal } from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';

import Alert from '../../../shared/components/Alert';

class SupplierModal extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    modal: PropTypes.bool,
    toggle: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func,
    postValue: PropTypes.objectOf(PropTypes.string),
    errorMsg: PropTypes.string,
  };

  static defaultProps = {
    title: 'Supplier',
    modal: false,
    postValue: {},
    handleSubmit: (e) => {
      e.preventDefault();
      console.log('submitted');
    },
    errorMsg: '',
  };

  constructor() {
    super();
    this.state = {};
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  render() {
    const {
      title, modal, toggle, handleChange, handleSubmit, postValue, errorMsg,
    } = this.props;

    return (
      <div>
        <Modal
          isOpen={modal}
          className="modal-dialog--primary modal-dialog--header"
        >
          <div className="modal__header bg_blue">
            <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
            <h4 className="bold-text  modal__title">{title.toString()}</h4>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal__body p-t-10">
              { errorMsg && (
                  <div className="notif_msg">
                    <Alert color="danger" className="alert--colored">
                      <p><span className="fa fa-exclamation">&nbsp;</span> { errorMsg }</p>
                    </Alert>
                  </div>
                )
              }
              <div className="form form--horizontal m-t-10">
                <div className="form__form-group">
                  <span className="form__form-group-label">Supplier Name <b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <input type="text" name="supplierName" value={postValue.supplierName ? postValue.supplierName : ''} placeholder="Name" onChange={handleChange} />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Contact Number</span>
                  <div className="form__form-group-field">
                    <input type="text" name="contactNumber" value={postValue.contactNumber ? postValue.contactNumber : ''} placeholder="Contact Number" onChange={handleChange} />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Address</span>
                  <div className="form__form-group-field">
                    <textarea name="address" value={postValue.address ? postValue.address : ''} placeholder="Address" onChange={handleChange} />
                  </div>
                </div>
                {
                  postValue.executeModal && postValue.executeModal === 'addsupplier' && (
                    <div className="form__form-group">
                      <span className="form__form-group-label">Current Balance</span>
                      <div className="form__form-group-field">
                        <input type="text" name="currentBalance" value={postValue.currentBalance ? postValue.currentBalance : ''} placeholder="Current Balance" onChange={handleChange} />
                      </div>
                    </div>
                  )
                }
              </div>
            </div>
            <ButtonToolbar className="modal__footer">
              <Button color="primary">Submit</Button>
              <Button onClick={toggle}>Cancel</Button>
            </ButtonToolbar>
          </form>
        </Modal>
      </div>
    );
  }
}

export default reduxForm({
  form: 'vertical_form_layout', // a unique identifier for this form
})(withTranslation('common')(SupplierModal));
